import {JSX} from 'react';
import {Services} from 'shared/ui/icons/hudIcons/services.tsx';
import {Search} from 'shared/ui/icons/hudIcons/search.tsx';
import {Dashboard} from 'shared/ui/icons/hudIcons/dashboard.tsx';
import {DocIcon} from 'shared/ui/icons/hudIcons/doc.tsx';
import {Hives} from 'shared/ui/icons/hudIcons/hives.tsx';
import {Diary} from 'shared/ui/icons/hudIcons/diary.tsx';
import {Calendar} from 'shared/ui/icons/hudIcons/calendar.tsx';
import {Analytics} from 'shared/ui/icons/hudIcons/analytics.tsx';
import {Registry} from 'shared/ui/icons/hudIcons/registry.tsx';
import {Scheme} from 'shared/ui/icons/hudIcons/scheme.tsx';
import {Pesticide} from 'shared/ui/icons/hudIcons/pesticide.tsx';
import {Employees} from 'shared/ui/icons/hudIcons/employees.tsx';
import {Notifications} from 'shared/ui/icons/hudIcons/notifications.tsx';
import {Support} from 'shared/ui/icons/hudIcons/support.tsx';
import {Settings} from 'shared/ui/icons/hudIcons/settings.tsx';
import {Other} from 'shared/ui/icons/hudIcons/other.tsx';
import {Logo} from 'shared/ui/icons/logo';
import {ConfigContextType} from '../../../app/App.tsx';

export type MatchMode = 'exact' | 'startsWith';

export type IconComponent = (props?: {fill?: string, height?: number}) => JSX.Element;

export type ClickableHudNavItem = {
  id: string;
  label: string;
  icon: IconComponent;
  iconActive: IconComponent;
  isClickable: true;
  adminOnly?: boolean;

  iconFill?: string;
  iconActiveFill?: string;
};

export type NonClickableHudNavItem = {
  id: string;
  to: string;
  label: string;
  match: MatchMode;
  icon: IconComponent;
  iconActive: IconComponent;
  isClickable?: false;
  adminOnly?: boolean;

  iconFill?: string;
  iconActiveFill?: string;
};

export type HudNavItem = ClickableHudNavItem | NonClickableHudNavItem;

export const TOP_NAV: HudNavItem[] = [
  {
    id: 'notifications',
    label: 'Уведомления',
    isClickable: true,
    icon: Notifications as IconComponent,
    iconActive: Notifications as IconComponent,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'search',
    isClickable: true,
    label: 'Поиск',
    icon: Search as IconComponent,
    iconActive: Search as IconComponent,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
];

export const MIDDLE_NAV: HudNavItem[] = [
  {
    id: 'dashboard',
    label: 'Моя пасека',
    icon: Dashboard as IconComponent,
    iconActive: Dashboard as IconComponent,
    to: '/',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'hives',
    label: 'Ульи',
    icon: Hives as IconComponent,
    iconActive: Hives as IconComponent,
    to: '/hives',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'diary',
    label: 'Журнал пчеловода',
    icon: Diary as IconComponent,
    iconActive: Diary as IconComponent,
    to: '/diary',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'calendar',
    label: 'Календарь',
    icon: Calendar as IconComponent,
    iconActive: Calendar as IconComponent,
    to: '/calendar',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'analytics',
    label: 'Погода на пасеке',
    icon: Analytics as IconComponent,
    iconActive: Analytics as IconComponent,
    to: '/weather',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'registry',
    label: 'Устройства',
    icon: Registry as IconComponent,
    iconActive: Registry as IconComponent,
    to: '/devices',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'scheme',
    label: 'Схема пасеки',
    icon: Scheme as IconComponent,
    iconActive: Scheme as IconComponent,
    to: '/scheme',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'pesticide',
    label: 'Карта пестицидов',
    icon: Pesticide as IconComponent,
    iconActive: Pesticide as IconComponent,
    to: '/pesticide-map',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'employees',
    label: 'Сотрудники',
    icon: Employees as IconComponent,
    iconActive: Employees as IconComponent,
    to: '/employees',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  // {
  //   id: 'horriot',
  //   label: 'Ветеринарный учёт',
  //   icon: DocIcon as IconComponent,
  //   iconActive: DocIcon as IconComponent,
  //   to: '/horriot',
  //   match: 'exact',
  //   iconActiveFill: 'rgba(255, 79, 18, 1)',
  //   adminOnly: false,
  // },
  // {
  //   id: 'mercury',
  //   label: 'ВСД',
  //   icon: DocIcon as IconComponent,
  //   iconActive: DocIcon as IconComponent,
  //   to: '/mercury/journal',
  //   match: 'exact',
  //   iconActiveFill: 'rgba(255, 79, 18, 1)',
  //   adminOnly: false,
  // },
];

export const BOTTOM_NAV: HudNavItem[] = [
  // {
  //   id: "services",
  //   label: "Наши сервисы",
  //   icon: Services as IconComponent,
  //   iconActive: Services as IconComponent,
  //   to: "/",
  //   match: "exact",
  //   iconActiveFill: "rgba(255, 79, 18, 1)",
  // },
  {
    id: 'services',
    label: 'Наши сервисы',
    icon: Services as IconComponent,
    iconActive: Services as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'support',
    label: 'Поддержка',
    icon: Support as IconComponent,
    iconActive: Support as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'settings',
    label: 'Настройки',
    icon: Settings as IconComponent,
    iconActive: Settings as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
];

export const getServicesNav = (config?: ConfigContextType): HudNavItem[] => {
  const services: HudNavItem[] = [
    {
      id: 'yourhive',
      label: 'ТвойУлей',
      icon: Logo as IconComponent,
      iconActive: Logo as IconComponent,
      to: config?.VITE_BEESHARE_HOST ? config.VITE_BEESHARE_HOST : '/breeding-portal',
      match: 'exact',
      iconActiveFill: 'rgba(255, 79, 18, 1)',
    },
    {
      id: 'selportal',
      label: 'Селекционный портал',
      icon: Logo as IconComponent,
      iconActive: Logo as IconComponent,
      to: '/breeding-portal',
      match: 'exact',
      iconActiveFill: 'rgba(255, 79, 18, 1)',
    },
    {
      id: 'honeyexchange',
      label: 'Биржа меда',
      icon: Logo as IconComponent,
      iconActive: Logo as IconComponent,
      to: '/honey-exchange',
      match: 'exact',
      iconActiveFill: 'rgba(255, 79, 18, 1)',
    },
  ];

  return services;
};

export const moreButton: HudNavItem = {
  id: 'other',
  label: 'Ещё',
  icon: Other as IconComponent,
  iconActive: Other as IconComponent,
  isClickable: true,
  iconActiveFill: 'rgba(255, 79, 18, 1)',
};

export const MOBILE_BOTTOM_NAV: HudNavItem[] = [
  {
    id: 'dashboard',
    label: 'Моя пасека',
    icon: Dashboard as IconComponent,
    iconActive: Dashboard as IconComponent,
    to: '/',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'diary',
    label: 'Журнал',
    icon: Diary as IconComponent,
    iconActive: Diary as IconComponent,
    to: '/diary',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'notifications',
    label: 'Уведомления',
    to: '/notifications',
    match: 'exact',
    icon: Notifications as IconComponent,
    iconActive: Notifications as IconComponent,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'services',
    label: 'Cервисы',
    icon: Services as IconComponent,
    iconActive: Services as IconComponent,
    to: '/services',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'settings',
    label: 'Настройки',
    icon: Settings as IconComponent,
    iconActive: Settings as IconComponent,
    isClickable: true,
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
];

export const MOBILE_MENU_NAV: HudNavItem[] = [
  {
    id: 'hives',
    label: 'Ульи',
    icon: Hives as IconComponent,
    iconActive: Hives as IconComponent,
    to: '/hives',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'diary',
    label: 'Журнал пчеловода',
    icon: Diary as IconComponent,
    iconActive: Diary as IconComponent,
    to: '/diary',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'calendar',
    label: 'Календарь',
    icon: Calendar as IconComponent,
    iconActive: Calendar as IconComponent,
    to: '/calendar',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'analytics',
    label: 'Погода на пасеке',
    icon: Analytics as IconComponent,
    iconActive: Analytics as IconComponent,
    to: '/weather',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'registry',
    label: 'Устройства',
    icon: Registry as IconComponent,
    iconActive: Registry as IconComponent,
    to: '/devices',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'scheme',
    label: 'Схема пасеки',
    icon: Scheme as IconComponent,
    iconActive: Scheme as IconComponent,
    to: '/scheme',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'pesticide',
    label: 'Карта пестицидов',
    icon: Pesticide as IconComponent,
    iconActive: Pesticide as IconComponent,
    to: '/pesticide-map',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  {
    id: 'employees',
    label: 'Сотрудники',
    icon: Employees as IconComponent,
    iconActive: Employees as IconComponent,
    to: '/employees',
    match: 'exact',
    iconActiveFill: 'rgba(255, 79, 18, 1)',
  },
  // {
  //   id: 'horriot',
  //   label: 'Ветеринарный учёт',
  //   icon: DocIcon as IconComponent,
  //   iconActive: DocIcon as IconComponent,
  //   to: '/horriot',
  //   match: 'exact',
  //   iconActiveFill: 'rgba(255, 79, 18, 1)',
  //   adminOnly: false,
  // },
  // {
  //   id: 'mercury',
  //   label: 'ВСД',
  //   icon: DocIcon as IconComponent,
  //   iconActive: DocIcon as IconComponent,
  //   to: '/mercury/journal',
  //   match: 'exact',
  //   iconActiveFill: 'rgba(255, 79, 18, 1)',
  //   adminOnly: false,
  // },
];
